import { LoaderFunction, MiddlewareFunction, redirect } from 'react-router-dom'
import { get, getDatabase, ref } from 'firebase/database'
import { tabNames } from '../routers/helpers'
import { authContext } from './auth'
import {
    SchoolAccountState,
    SchoolUserAccountState,
    SchoolUserAuthority,
} from '../firebase/types-school'
import { db } from '../firebase/configs'
import { getCached, setCached } from './cache'
import { logger } from '../helpers/logger'

export const redirectToDefaultSchoolLoader: LoaderFunction = async ({
    context,
}) => {
    const user = context.get(authContext)

    if (!user?.uid) {
        throw redirect('/')
    }

    try {
        const schoolUidSnapshot = await get(
            ref(getDatabase(), `users/${user.uid}/schoolUidWeb`)
        )
        const schoolId = schoolUidSnapshot.val()

        if (typeof schoolId === 'string' && schoolId.length > 0) {
            throw redirect(`${tabNames.app.school.index}/${schoolId}`)
        }
    } catch (error) {
        if (error instanceof Response) {
            throw error
        }
    }
    throw redirect(`/${tabNames.app.index}`)
}

export const schoolMembershipMiddleware: MiddlewareFunction = async ({
    context,
    params,
}) => {
    const user = context.get(authContext)!
    const { schoolId } = params

    if (!schoolId) {
        // Navigate back to root to determine schoolId
        throw redirect(`${tabNames.app.school.index}`)
    }

    // console.log(`Checking ${user.uid} in ${schoolId}`)
    let membershipCheck = getCached<boolean>(`membership-${schoolId}`)
    if (membershipCheck === null) {
        const membershipSnapshot = await get(
            ref(db, `users/${user.uid}/schools/${schoolId}`)
        )
        membershipCheck = !membershipSnapshot.exists()
        setCached(`membership-${schoolId}`, membershipCheck)
    }
    if (membershipCheck) {
        logger.warn(`User not part of school`)
        throw redirect('/dashboard')
    }
}

export const canAccessMySchool = (
    accountState: SchoolAccountState,
    userAccountState: SchoolUserAccountState,
    role: SchoolUserAuthority
) => {
    switch (accountState) {
        case 'pendingApproval':
        case 'approved': {
            if (userAccountState !== 'approved' && role !== 'admin') {
                return false
            }
            return true
        }
        default: {
            return false
        }
    }
}
